import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MuiTableRow from '@material-ui/core/TableRow';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
  bodyRow: {
    //border: `solid 1px ${theme.colors.eyGrey3}`,
    boxShadow: '0 0 4px 0 rgba(0,0,0,0.03)',
    '&:hover': {
      border: '2px solid rgba(0, 0, 0, 0.2)',
    },
  },
  headerRow: {},
  oddRow: {
    backgroundColor: '#FBFBFD',
  },
  evenRow: {},
});

class TableRow extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  static defaultProps = {
    rowType: 'body',
  };

  render() {
    const { classes, children, onClick, rowType, rowIndex } = this.props;
    const rowClass = classNames({
      [classes.root]: true,
      [classes.bodyRow]: rowType === 'body',
      [classes.headerRow]: rowType === 'head',
      [classes.oddRow]: rowIndex % 2 !== 0,
      [classes.evenRow]: rowIndex % 2 === 0,
    });

    return (
      <MuiTableRow className={rowClass} onClick={onClick}>
        {children}
      </MuiTableRow>
    );
  }
}

export default styled(TableRow)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Table/components/TableRow.js